var ViewPropTypes = { style: null }
export default ViewPropTypes;
